import {createAction} from 'Shared/utilities/actionCreator';
import {Dependents} from '../models/Dependents';
import {DependentLists} from 'ApplicationEntry/models/DependentLists';
import * as D from '../models/DependentLists';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import * as I from 'immutable';

export enum DependentListActionType {
  ADD_DEPENDENTS = 'dependents/ADD_DEPENDENTS',
  REMOVE_DEPENDENT = 'dependents/REMOVE_DEPENDENT',
  UPDATE_DEPENDENT_LIST = 'dependents/UPDATE_DEPENDENT_LIST',
}

export const addDependents = (dependents: I.List<Dependents>) => {
  return createAction(DependentListActionType.ADD_DEPENDENTS, {dependents});
};

export const removeDependent = (index: number) => {
  return createAction(DependentListActionType.REMOVE_DEPENDENT, {index});
};

export const updateDependentList = (dependents: Dependents, index: number) => {
  return createAction(DependentListActionType.UPDATE_DEPENDENT_LIST, {dependents, index});
};

export type DependentListAction =
  | ReturnType<typeof addDependents>
  | ReturnType<typeof removeDependent>
  | ReturnType<typeof updateDependentList>;

export const isDependentListAction = (action: any): action is DependentListAction =>
  action.type in reverseEnum(DependentListActionType);

type DependentListState = DependentLists;
const DEFAULT_STATE: DependentListState = D.EmptyDependentList;

export default (state: DependentListState = DEFAULT_STATE, action: DependentListAction): DependentListState => {
  switch (action.type) {
    case DependentListActionType.ADD_DEPENDENTS:
      const {dependents} = action.payload;
      return D.addDependents(dependents)(state.dependentList);
    case DependentListActionType.REMOVE_DEPENDENT:
      return D.removeDependents(action.payload.index)(state.dependentList);
    case DependentListActionType.UPDATE_DEPENDENT_LIST:
      return D.updateDependentList(action.payload.dependents, action.payload.index)(state.dependentList);
    default:
      return state;
  }
};
